import { z } from "zod";
import { dnaCoreSchema } from "../../dna/schema.js";
/**
 * `ReferenceUploaded` (musical, v1) — NEW (spec §4.1). Appended by the API at
 * upload time, before the `dna-analysis` job runs. The fact "this audio clip
 * was received as a reference in this project".
 *
 * When `source === "mashup"` the `dna` is the already-computed blend result —
 * there is no analysis job. When `source === "upload"` `dna` is absent and the
 * DNA arrives later via `ReferenceAnalyzed`. Born at v1 — no upcaster.
 */
export const referenceUploadedPayloadSchema = z.object({
    referenceId: z.string().min(1),
    assetHash: z.string().regex(/^[0-9a-f]{64}$/),
    label: z.string().min(1).max(80),
    source: z.enum(["upload", "mashup"]),
    role: z.enum(["primary", "secondary"]),
    dna: dnaCoreSchema.nullable(),
    uploadedAt: z.string().datetime(),
});
/**
 * `ReferenceAnalyzed` (musical, v1) — NEW (spec §4.2). Appended by the
 * `DNAAnalysisHandler` when Essentia finishes. Links the extracted DNA to the
 * `referenceId` of the originating upload. Born at v1 — no upcaster.
 */
export const referenceAnalyzedPayloadSchema = z.object({
    referenceId: z.string().min(1),
    bpm: z.number().positive().max(300),
    key: z.string().min(1),
    mood: z.string().min(1),
    analyzedAt: z.string().datetime(),
});
/**
 * `ReferenceRemoved` (musical, v1) — NEW (spec §10 #10, §12 un-defer). Appended
 * by the API when the user removes a DNA reference from a project. Event-sourced
 * "remove": the original `ReferenceUploaded` stays in the log forever, and the
 * reducer simply drops the matching `dnaReferences[]` entry on replay. If the
 * removed reference was the active `primary`, the reducer promotes the most
 * recent surviving analyzed reference to `primary` (or `null` if none remain).
 * An unknown `referenceId` is a no-op (fail-soft). Born at v1 — no upcaster.
 */
export const referenceRemovedPayloadSchema = z.object({
    referenceId: z.string().min(1),
    removedAt: z.string().datetime(),
});
//# sourceMappingURL=reference.js.map